module.exports = __webpack_public_path__ + "img/Pic_TB_D.ac943f00.png";